import template from './lock_open_errors.html';
import controller from './lock_open_errors.controller';
import './lock_open_errors.scss';

let branchManagementLockOpenErrorsComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementLockOpenErrorsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/lock_open_errors/lock_open_errors.component.js